<template>
  <div v-show="boxShow" class="box" @touchmove.stop="noTouch">
    <div class="box-mask" :class="{'show':showAnimate}" @click="closeToast"></div>
    <div class="box-container" :class="{'show':showAnimate}">
      <div class="close-btn" @click="closeToast">
        <img src="https://wecos.etczs.net/assets/images/toast-close.png" />
      </div>
      <div class="box-title">
        <div class="t">{{title}}</div>
      </div>
      <div class="box-content">
        <slot></slot>
        <div v-if="isRichMan" class="long-phone-btn"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    noTouch() {
      return false
    },
    // 关闭弹窗
    closeToast(isClose = true) {
      this.$emit('close')
    },
    // 打开/关闭弹窗
    showBox() {
      if (!this.show) {
        this.showAnimate = false
        setTimeout(() => {
          this.boxShow = false
        }, 300)
      } else {
        this.boxShow = true
        setTimeout(() => {
          this.showAnimate = true
        }, 10)
      }
    }
  },
  watch: {
    show() {
      this.showBox()
    }
  },
  props: {
    show: Boolean,
    title: String
  },
  data: () => ({
    boxShow: false,
    showAnimate: false
  })
}
</script>

<style lang="scss" scoped>
.flex-c {
  display: flex;
  align-items: center;
}
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 12;
  top: 0;
  left: 0;
  overflow: hidden;
  .box-mask {
    position: fixed;
    z-index: 21;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    transition: opacity 0.3s;
    opacity: 0;
    &.show {
      opacity: 0.5;
    }
  }
  .box-container {
    position: absolute;
    background-color: #fff;
    border-radius: 32px 32px 0 0;
    z-index: 22;
    width: 100%;
    box-sizing: border-box;
    padding: 40px;
    left: 0;
    bottom: 0;
    transition: transform 0.3s;
    transform: translateY(100%);
    // &.
    &.show {
      transform: translateY(0);
    }
    .close-btn {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 28px;
      height: 28px;
      padding: 40px;
      box-sizing: content-box;
      img {
        display: block;
        width: 28px;
        height: 28px;
      }
    }
    .box-title {
      // margin-left: -40px;
      margin-top: -10px;
      line-height: 50px;
      font-size: 36px;
      font-weight: 500;
      padding-bottom: 30px;
      text-align: center;
    }
    .box-content {
      // padding: 0 40px;
      .box-box-img {
        background: #e9faef;
        border-radius: 10px;
        padding: 15px 45px;
        padding-right: 20px;
        margin-bottom: 55px;
        img {
          width: 160px;
          height: 78px;
        }
        div {
          font-size: 26px;
          color: #333;
          margin-left: 17px;
          line-height: 40px;
        }
      }
      .box-box-field {
        display: flex;
        align-items: flex-start;
        margin-bottom: 40px;
        .icon {
          width: 56px;
          height: 56px;
          margin-right: 20px;
        }
        &_subtext {
          font-size: 28px;
          color: #666666;
          margin-top: 12px;
        }
        &_text {
          font-size: 32px;
          color: #333;
          line-height: 56px;
        }
      }
    }
  }
}
</style>
